import DarkModeCode from "!!raw-loader!./buttons/DarkMode";
import DesignCode from "!!raw-loader!./buttons/Design.tsx";
import DisabledCode from "!!raw-loader!./buttons/Disabled.tsx";
import EndIconCode from "!!raw-loader!./buttons/EndIcon.tsx";
import FullWidthCode from "!!raw-loader!./buttons/FullWidth.tsx";
import LocalizedCode from "!!raw-loader!./buttons/Localized.tsx";
import OverflowButtonCode from "!!raw-loader!./buttons/OverflowButton";
import SmallCode from "!!raw-loader!./buttons/Small.tsx";
import SplitButtonCode from "!!raw-loader!./buttons/SplitButton";
import StartIconCode from "!!raw-loader!./buttons/StartIcon.tsx";
import TooltipCode from "!!raw-loader!./buttons/Tooltip";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import DarkMode from "./buttons/DarkMode";
import Design from "./buttons/Design";
import Disabled from "./buttons/Disabled";
import EndIcon from "./buttons/EndIcon";
import FullWidth from "./buttons/FullWidth";
import Localized from "./buttons/Localized";
import OverflowButton from "./buttons/OverflowButton";
import Small from "./buttons/Small";
import SplitButton from "./buttons/SplitButton";
import StartIcon from "./buttons/StartIcon";
import Tooltip from "./buttons/Tooltip";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Design", DesignCode, Design),
		paneComponent("Dark Mode", DarkModeCode, DarkMode),
		paneComponent("Start Icon", StartIconCode, StartIcon),
		paneComponent("End Icon", EndIconCode, EndIcon),
		paneComponent("Size Small", SmallCode, Small),
		paneComponent("Disabled", DisabledCode, Disabled),
		paneComponent("Localized", LocalizedCode, Localized),
		paneComponent("Full Width", FullWidthCode, FullWidth),
		paneComponent("Tooltip Text", TooltipCode, Tooltip),
		paneComponent("Overflow Button", OverflowButtonCode, OverflowButton),
		paneComponent("Split Button", SplitButtonCode, SplitButton),
	];

	return (
		<Pane
			components={components}
			imports='import {Button} from "designSystem/index";'
			muiApi="button"
			muiComponent="buttons"
			{...props}
		/>
	);
};